var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col items-center relative"},[_c('div',{staticClass:"w-full flex justify-center"},[_c('div',{staticClass:"w-11/12 mb-20"},[_vm._t("default"),_c('BackToTop')],2)]),_c('Modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }